import {createSlice} from '@reduxjs/toolkit';

let initialState = {};

if (localStorage.getItem("token")?.length > 0) {
	initialState = {
		isLogin: true,
		currentUser: JSON.parse(localStorage.getItem("userData")),
	};
} else {
	initialState = {
		isLogin: false,
		currentUser: {},
	};
}

const authSlice = createSlice({
	name: 'auth',
	initialState,
	reducers: {
		setCurrentUser(state, action) {
			state.currentUser = action.payload;
			state.isLogin = true;
		},
		logout(state) {
			state.currentUser = {};
			state.isLogin = false;
		}
	},
});

export const {setCurrentUser} = authSlice.actions;
export const {logout} = authSlice.actions;
const authReducer = authSlice.reducer;

export default authReducer;
